/* This file was automatically generated - please modify the template not this file! */

import { createSelector } from "reselect";

import { routeIdSelector as immunisationTypeIdSelector } from "../immunisationType/selectors";
import { ImmunisationTypeState } from "../immunisationType";

import { ImmunisationTypeTask, AppState } from "./model";

export const routeIdSelector = (state: AppState) => {
    return state.router.params.immunisationTypeTaskId;
};

export const taskNameSelector = (state: AppState) => {
    return state.router.query?.name || "";
};

export type SelectorState = AppState & ImmunisationTypeState;

export const immunisationTypeTasksSelector = (state: SelectorState) =>  {
    const immunisationTypeId = immunisationTypeIdSelector(state);
    let immunisationTypeTasks = state.immunisationTypeTasks;

    if (immunisationTypeId) {
        immunisationTypeTasks = immunisationTypeTasks.filter(p => p.immunisationTypeId === immunisationTypeId);
    }
    return immunisationTypeTasks;
};

export const immunisationTypeTaskSelector = createSelector(
    immunisationTypeTasksSelector,
    routeIdSelector,
    (immunisationTypeTasks: ImmunisationTypeTask[], id: any) => {
        return immunisationTypeTasks.filter(c => c.id === id)[0] || {} as ImmunisationTypeTask;
    }
);

export const basePathSelector = (state: AppState) =>
    state.router.pathname.substring(0, state.router.pathname.indexOf("tasks") + "tasks".length);
